import React from "react";
import { FormattedMessage } from "react-intl";

export const getOtherCasesDataTableConfig = (
  data,
  isEditable,
  { onOpenDeleteOtherCaseDialog }
) => ({
  static_data: data,
  backend_querying: false,
  header: {},
  columns: [
    {
      db_field: "datum",
      title: "label_date",
      type: "date",
      width: "15%",
    },
    {
      db_field: "crime_case_type",
      title: "type_label",
      type: "text",
      width: "10%",
    },
    {
      db_field: "document_id",
      title: "label_document_id",
      type: "text",
      width: "35%",
    },
    {
      db_field: "filename",
      title: "label_filename",
      type: "text",
      width: "35%",
    },
    {
      type: "actions",
      width: "5%",
      isHidden: !isEditable,
      actions: [
        {
          label: <FormattedMessage id="label_download_court_document" />,
          icon: "icon-menu-report",
          type: "button",
          onClick: ({ document_download_link }) => {
            window.open(document_download_link, "_blank");
          },
        },
        {
          label: <FormattedMessage id="label_delete" />,
          icon: "icon-menu-trash",
          type: "button",
          onClick: onOpenDeleteOtherCaseDialog,
        },
      ],
    },
  ],
});
